






import Vue from 'vue'
import Avatar from '@/components/Avatar/avatar.vue'
import Student from '@/models/Students/Student'
import User from '@/models/Users/User'
import StatusComponent from '../../UserStatus.vue'

export default Vue.extend({
  name: 'UserStatusCol',
  components: {
    StatusComponent
  },
  props: {
    row: Object as () => User,
  }
})
